import { DailyCutoffDataType } from "../../../types";
import { formatDate } from "../../../utils/date";
import { formatNumberWithCommas } from "../../../utils/numbers";

type GenerateProps = {
  meterSerialNo: string;
  results: DailyCutoffDataType[];
  showLiters: boolean;
};

function formatVolume(value: number | null | undefined, showLiters: boolean): string {
  if (value === null || value === undefined) return "--";
  if (showLiters) return formatNumberWithCommas(Math.round(value));
  const truncated = Math.trunc(value / 10) / 100;
  return formatNumberWithCommas(truncated);
}

export default function generateDailyCutoffsCsv({ meterSerialNo, results, showLiters }: GenerateProps) {
  const unitLabel = showLiters ? "(l)" : "(units)";

  const headers = [
    "Date",
    `Previous Rd. ${unitLabel}`,
    `Current Rd. ${unitLabel}`,
    `Consumption ${unitLabel}`,
    "Temp (°C)",
    "Alarm",
  ];

  const rows = results.map((row) => {
    const current = row.totalVolume;
    const previous = row.previousVolume;
    const consumption = previous !== null && previous !== undefined ? current - previous : null;

    return [
      formatDate(row.deviceDateTime),
      previous !== null && previous !== undefined ? formatVolume(previous, showLiters) : "--",
      formatVolume(current, showLiters),
      consumption !== null ? formatVolume(Math.abs(consumption), showLiters) : "--",
      row.temperature !== null && row.temperature !== undefined
        ? Number(row.temperature).toFixed(2)
        : "--",
      row.alarmSummary || "None",
    ].map((cell) => `"${String(cell).replace(/"/g, '""')}"`);
  });

  const csvContent = [headers.map((h) => `"${h}"`).join(","), ...rows.map((r) => r.join(","))].join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `daily-report-${meterSerialNo}.csv`;
  link.click();
  URL.revokeObjectURL(url);
}
